import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ListAssistance from './ListAssistance'

import EditAssistance from './EditAssistance'
import NewAssistance from './NewAssistance'

const SpecialistAssistanceRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListAssistance /></PrivateRoute7>} />
        <Route path="edit-assistance" element={<PrivateRoute7><EditAssistance /></PrivateRoute7>} />
        <Route path="new-assistance" element={<PrivateRoute7><NewAssistance /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistAssistanceRoutes